const LICENSE_GROUP_USER_LIST_CACHE_ID = 'LicenseGroupUserList';

const LICENSE_GROUP_USER_LIST_EVENT = {
  UPDATE: {
    COUNT: 'UpdateLicenseGroupUsersCount',
    LIST: 'UpdateLicenseGroupUsersList',
  },
};

export {LICENSE_GROUP_USER_LIST_CACHE_ID, LICENSE_GROUP_USER_LIST_EVENT};
